import React from 'react';
import PropTypes from 'prop-types';
import { renderImage, COLLECTION_THUMBNAIL_IMAGE } from 'helpers/ImageHelper';
import Image from 'components/Tile/components/Image';
import VideoTile from 'components/VideoTile';

const ImageElement = props => {
  const { breakpoint, hoverImage, image, isHoverActive, theme, video } = props;
  if (isHoverActive) {
    if (video) {
      const imageRenderer = opts =>
        renderImage({ breakpoint, imageType: COLLECTION_THUMBNAIL_IMAGE, ...opts });
      return (
        <VideoTile
          id={video ? `tile-video-${video}` : undefined}
          image={image}
          load
          loop
          play
          renderImage={imageRenderer}
          timer={0}
          video={video}
        />
      );
    }
    if (hoverImage) {
      return (
        <Image
          breakpoint={breakpoint}
          imageType={COLLECTION_THUMBNAIL_IMAGE}
          src={hoverImage}
          theme={theme}
        />
      );
    }
  }
  const imageSrc = image || hoverImage;
  if (imageSrc) {
    return (
      <Image
        breakpoint={breakpoint}
        imageType={COLLECTION_THUMBNAIL_IMAGE}
        src={imageSrc}
        theme={theme}
      />
    );
  }
  return null;
};

export default ImageElement;

ImageElement.defaultProps = {
  hoverImage: null,
  image: null,
  video: null,
};

ImageElement.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  hoverImage: PropTypes.string,
  image: PropTypes.string,
  isHoverActive: PropTypes.bool.isRequired,
  theme: PropTypes.shape({}).isRequired,
  video: PropTypes.string,
};
